import {
    Button, Col, Dropdown, Input, Row, SegmentControl, Text
} from 'components';
import { storage } from 'core';
import { Api, nations, theme, validateEmail } from 'lib';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const checkboxOptions = [
  { text: `I'm an athlete`, value: 'athlete' },
  { text: `I'm a fan`, value: 'fan' }
];

const SignUp = ({ setData }) => {
  const [firstName, setFirstname] = useState(''),
    [lastName, setLastname] = useState(''),
    [email, setEmail] = useState(''),
    [country, setCountry] = useState(''),
    [userType, setUserType] = useState(0),
    [referalCode, setReferalCode] = useState(''),
    [phone, setPhone] = useState(''),
    [password, setPassword] = useState(''),
    [errs, setErrs] = useState([]),
    navigate = useNavigate(),
    { isMobile } = global,
    dispatch = useDispatch();

  useEffect(() => {
    const firstInput = document.getElementById('first-name-input');
    firstInput.focus();
  }, []);

  function handleUserType(e) {
    setReferalCode('');
    setUserType(e);
  }

  async function handleSubmit() {
    setErrs([]);
    if (!firstName || !lastName || !validateEmail(email) || password.length < 12) {
      let errors = [];

      switch (true) {
        case !firstName:
          errors.push({ input: 'firstName', err: 'Required.' });

        case !lastName:
          errors.push({ input: 'lastName', err: 'Required.' });

        case !validateEmail(email):
          errors.push({ input: 'email', err: 'Invalid email.' });

        case password.length < 12:
          if (password.length < 12)
            errors.push({ input: 'password', err: 'Password must be at least 12 characters.' });
      }

      return setErrs(errors);
    }

    const data = {
      firstName,
      lastName,
      email,
      country: country.value,
      phone,
      type: userType === 1 ? 'athlete' : 'fan',
      password,
      referalCode
    };

    const res = await Api.post('/users/signUp', data, 'signup');
    if (!res) return;

    storage.setItem('token', res.token);

    dispatch({
      type: 'SET_USER',
      payload: { ...res.user, fromSignup: true }
    });
  }

  return (
    <Col wid={isMobile ? '286px' : '480px'} center>
      <Row center>
        <Text marg="0 0 38px" size={isMobile ? '18px' : '20px'} weight="700" col={theme.SECONDARY}>
          REGISTER
        </Text>
      </Row>

      <SegmentControl
        options={['Fan', 'Athlete']}
        selectedIdx={userType}
        handleSelect={handleUserType}
        marg="0 0 30px"
      />

      <Text marg="0 0 6px" size="20px" bold col={theme.SECONDARY}>
        YOUR DETAILS
      </Text>

      <Input
        form
        website
        err={errs.find((x) => x.input === 'firstName')}
        id="first-name-input"
        value={firstName}
        placeholder="First Name"
        onChange={({ target }) => setFirstname(target.value)}
        marg="8px 0"
      />

      <Input
        form
        website
        err={errs.find((x) => x.input === 'lastName')}
        value={lastName}
        placeholder="Last Name"
        onChange={({ target }) => setLastname(target.value)}
        marg="8px 0"
      />

      <Input
        form
        website
        password
        err={errs.find((x) => x.input === 'password')}
        value={password}
        placeholder="Password"
        onChange={({ target }) => setPassword(target.value)}
        marg="8px 0"
      />

      <Text marg="27px 0 6px" size="20px" weight="700" col={theme.SECONDARY}>
        CONTACT INFORMATION
      </Text>

      <Input
        form
        website
        value={email}
        err={errs.find((x) => x.input === 'email')}
        placeholder="Email Address"
        onChange={({ target }) => setEmail(target.value)}
        marg="8px 0"
      />

      <Dropdown
        title="Country"
        marg="8px 0"
        options={nations}
        selected={country}
        handleSelect={setCountry}
        website
      />

      <Input
        form
        website
        value={phone}
        placeholder="Phone number"
        onChange={({ target }) => setPhone(target.value)}
        marg="8px 0"
      />

      {userType === 1 && (
        <Input
          form
          website
          value={phone}
          placeholder="Referal Code (Optional)"
          onChange={({ target }) => setPhone(target.value)}
          marg="8px 0"
        />
      )}

      <Button marg="32px 0" website text="Submit" action="signup" contain onClick={handleSubmit} />
    </Col>
  );
};

export default SignUp;
